var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Event from 'typescript.events';
var GeolocationWrapper = /** @class */ (function (_super) {
    __extends(GeolocationWrapper, _super);
    function GeolocationWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._LastResult = null;
        _this.status = 'pending';
        _this.clearWacher = null;
        return _this;
    }
    Object.defineProperty(GeolocationWrapper.prototype, "LastResult", {
        get: function () { return this._LastResult; },
        enumerable: false,
        configurable: true
    });
    ;
    GeolocationWrapper.prototype.setLastResult = function (position) {
        this._LastResult = position;
        this.emit('change', position, this.status);
    };
    Object.defineProperty(GeolocationWrapper.prototype, "isRunning", {
        get: function () { return this.status === 'running'; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeolocationWrapper.prototype, "isPending", {
        get: function () { return this.status === 'pending'; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeolocationWrapper.prototype, "isDeny", {
        get: function () { return this.status === 'deny'; },
        enumerable: false,
        configurable: true
    });
    GeolocationWrapper.prototype.on = function (event, listener) { return _super.prototype.on.call(this, event, listener); };
    GeolocationWrapper.prototype.authorize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, navigator.permissions.query({ name: "geolocation" })];
                    case 1:
                        result = _a.sent();
                        if (result.state == "granted" || result.state == "prompt") {
                            this.status = 'pending';
                            return [2 /*return*/, true];
                        }
                        else {
                            this.status = 'deny';
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    GeolocationWrapper.prototype.current = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var position;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof window === 'undefined')
                            return [2 /*return*/];
                        if (!options)
                            options = { enableHighAccuracy: true, timeout: 5000, maximumAge: 10 };
                        return [4 /*yield*/, this.authorize()];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, new Promise(function (r, e) { return navigator.geolocation.getCurrentPosition(function (position) { return r(position); }, function (err) { return e(err); }, options); })];
                    case 2:
                        position = _a.sent();
                        this.setLastResult(position);
                        return [2 /*return*/, position];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GeolocationWrapper.prototype.watch = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var current, wathId_1, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof window === 'undefined')
                            return [2 /*return*/];
                        if (this.isRunning)
                            return [2 /*return*/, null];
                        if (!options)
                            options = { enableHighAccuracy: true, timeout: 5000, maximumAge: 5000 };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.current(options)];
                    case 2:
                        current = _a.sent();
                        if (current && this.isPending) {
                            wathId_1 = navigator.geolocation.watchPosition(function (position) {
                                _this.status = 'running';
                                _this.setLastResult(position);
                            }, function (error) {
                                _this.status = 'deny';
                            }, options);
                            this.status = 'running';
                            this.clearWacher = function () { return navigator.geolocation.clearWatch(wathId_1); };
                            return [2 /*return*/, current];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GeolocationWrapper.prototype.start = function (options) {
        if (this.isRunning)
            return this.LastResult;
        return this.watch(options);
    };
    GeolocationWrapper.prototype.stop = function (options) {
        if (typeof window === 'undefined')
            return;
        if (!this.isRunning)
            return;
        this.clearWacher && this.clearWacher();
        this.status = 'pending';
    };
    return GeolocationWrapper;
}(Event));
export { GeolocationWrapper };
var Geolocation = new GeolocationWrapper();
export { Geolocation };
